import React from 'react'
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import blog_icon01 from "../../../screenassets/images/blog/01.jpg";
import blog_icon02 from "../../../screenassets/images/blog/02.jpg";
import blog_icon03 from "../../../screenassets/images/blog/03.jpg";
import blog_icon04 from "../../../screenassets/images/blog/04.jpg";
import blog_icon05 from "../../../screenassets/images/blog/05.jpg";
import blog_icon06 from "../../../screenassets/images/blog/06.jpg";
import blog_icon07 from "../../../screenassets/images/blog/07.jpg";
import blog_icon08 from "../../../screenassets/images/blog/08.jpg";
import blog_icon09 from "../../../screenassets/images/blog/09.jpg";
import blog_icon10 from "../../../screenassets/images/blog/04.png";
import blog_icon11 from "../../../screenassets/images/blog/05.png";
import blog_icon12 from "../../../screenassets/images/blog/06.png";
import blog_icon13 from "../../../screenassets/images/cta/02.png";


export default function Blog() {
    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Blog Posts</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Blog Posts</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="rts-blog-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon01} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                Five Things You Need to Know about Writing Articles
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon10} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon02} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">blog Content</span>
                                        <span className="time">4 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                15 AI Prompts to Supercharge Sales &amp; Marketing Teams
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon11} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon03} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                Introducing Infobase by Copy ai: Your Team’s Brand Center
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon12} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon04} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                Five Things You Need to Know about Writing Articles
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon12} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="blog-details.html">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon05} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">blog Content</span>
                                        <span className="time">4 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                15 AI Prompts to Supercharge Sales &amp; Marketing Teams
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon11} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon06} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="blog-details.html">
                                            <h5 className="title">
                                                Introducing Infobase by Copy ai: Your Team’s Brand Center
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon12} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="blog-details.html">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon07} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="blog-details.html">
                                            <h5 className="title">
                                                Five Things You Need to Know about Writing Articles
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon11} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>



                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon08} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">blog Content</span>
                                        <span className="time">4 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="blog-details">
                                            <h5 className="title">
                                                15 AI Prompts to Supercharge Sales &amp; Marketing Teams
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon11} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="single-blog-area-wrapper">
                                <Link to="/blog-details" className="thumbnail">
                                    <img src={blog_icon09} alt="Blog_images" />
                                </Link>
                                <div className="inner-content">
                                    <div className="head">
                                        <span className="tag">Content Write</span>
                                        <span className="time">7 min Read</span>
                                    </div>
                                    <div className="body">
                                        <Link to="/blog-details">
                                            <h5 className="title">
                                                Introducing Infobase by Copy ai: Your Team’s Brand Center
                                            </h5>
                                        </Link>
                                        <div className="author-area">
                                            <div className="author">
                                                <img src={blog_icon12} alt="blog-area" />
                                                <div className="info">
                                                    <p>samuel</p>
                                                    <span>Author</span>
                                                </div>
                                            </div>
                                            <Link to="/blog-details">Read More <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>




            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" class="rts-btn btn-primary"> Get Started Now </Link>
                                </div>
                                <div class="right">
                                    <img src={blog_icon13} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Footer Section */}
            <Footer />

        </>
    )
}
